import { Texture } from "@/core/backends/webgl/texture"
import { DenoiseTextures } from "@/core/pipeline/passes/wavelet-denoise-pass"
import { vec2 } from "gl-matrix"

export const CHUNK_PADDING = 64
export const CHUNK_SIZE = 1280

export const blitDenoiseChunkTexturesIntoFinalTextures = (
	gl: WebGL2RenderingContext,
	fboDraw: WebGLFramebuffer,
	fboRead: WebGLFramebuffer,
	chunkTextures: {
		denoiseLumTexture: Texture
		denoiseColorTexture: Texture
	},
	outputTextures: DenoiseTextures,
	offset: vec2,
) => {
	// Copying denoise texture
	gl.bindFramebuffer(gl.READ_FRAMEBUFFER, fboRead)
	gl.framebufferTexture2D(
		gl.READ_FRAMEBUFFER,
		gl.COLOR_ATTACHMENT0,
		gl.TEXTURE_2D,
		chunkTextures.denoiseLumTexture.nativeTexture,
		0,
	)
	gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, fboDraw)
	gl.framebufferTexture2D(
		gl.DRAW_FRAMEBUFFER,
		gl.COLOR_ATTACHMENT0,
		gl.TEXTURE_2D,
		outputTextures.denoiseLumTexture.nativeTexture,
		0,
	)
	gl.blitFramebuffer(
		CHUNK_PADDING,
		CHUNK_PADDING,
		CHUNK_PADDING + CHUNK_SIZE,
		CHUNK_PADDING + CHUNK_SIZE,
		offset[0],
		offset[1],
		offset[0] + CHUNK_SIZE,
		offset[1] + CHUNK_SIZE,
		gl.COLOR_BUFFER_BIT,
		gl.LINEAR,
	)

	const pad2 = CHUNK_PADDING / 2
	const x0_2 = Math.floor(offset[0] / 2)
	const y0_2 = Math.floor(offset[1] / 2)
	const w2 = Math.floor(CHUNK_SIZE / 2)
	const h2 = Math.floor(CHUNK_SIZE / 2)

	gl.bindFramebuffer(gl.READ_FRAMEBUFFER, fboRead)
	gl.framebufferTexture2D(
		gl.READ_FRAMEBUFFER,
		gl.COLOR_ATTACHMENT0,
		gl.TEXTURE_2D,
		chunkTextures.denoiseColorTexture.nativeTexture,
		0,
	)
	gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, fboDraw)
	gl.framebufferTexture2D(
		gl.DRAW_FRAMEBUFFER,
		gl.COLOR_ATTACHMENT0,
		gl.TEXTURE_2D,
		outputTextures.denoiseColorTexture.nativeTexture,
		0,
	)
	gl.blitFramebuffer(
		pad2,
		pad2,
		pad2 + w2,
		pad2 + h2,
		x0_2,
		y0_2,
		x0_2 + w2,
		y0_2 + h2,
		gl.COLOR_BUFFER_BIT,
		gl.LINEAR,
	)

	gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null)
	gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null)
}

export const blitChunkTextureIntoFinalTexture = (
	gl: WebGL2RenderingContext,
	fboDraw: WebGLFramebuffer,
	fboRead: WebGLFramebuffer,
	chunkTexture: Texture,
	outputTexture: Texture,
	offset: vec2,
) => {
	gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, fboDraw)
	gl.framebufferTexture2D(
		gl.DRAW_FRAMEBUFFER,
		gl.COLOR_ATTACHMENT0,
		gl.TEXTURE_2D,
		outputTexture.nativeTexture,
		0,
	)
	gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null)

	gl.bindFramebuffer(gl.READ_FRAMEBUFFER, fboRead)
	gl.framebufferTexture2D(
		gl.READ_FRAMEBUFFER,
		gl.COLOR_ATTACHMENT0,
		gl.TEXTURE_2D,
		chunkTexture.nativeTexture,
		0,
	)
	gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, fboDraw)

	const dstX = offset[0]
	const dstY = offset[1]
	const srcX = CHUNK_PADDING
	const srcY = CHUNK_PADDING

	gl.blitFramebuffer(
		srcX,
		srcY,
		srcX + CHUNK_SIZE,
		srcY + CHUNK_SIZE,

		dstX,
		dstY,
		dstX + CHUNK_SIZE,
		dstY + CHUNK_SIZE,

		gl.COLOR_BUFFER_BIT,
		gl.LINEAR,
	)

	gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null)
	gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null)
}
